
export const crowdingData = [
  {
    label: "Expansion and stripping (if needed)",
    value: "Expansion and stripping (if needed)"
  },
  {
    label: "Expansion and proclinaition and stripping (if needed)",
    value: "Expansion and proclinaition and stripping (if needed)"
  },
  {
    label: "Extraction of lower incisors to resolve the lower anterior crowding",
    value: "Extraction of lower incisors to resolve the lower anterior crowding"
  },
  {
    label: "Not correct the crowding",
    value: "Not correct the crowding"
  },
]

export const spacingData = [
  {
    label: "Close all the spaces",
    value: "Close all the spaces"
  },
  {
    label: "Keep spaces distal to lateral incisors",
    value: "Keep spaces distal to lateral incisors"
  },
  {
    label: "Keep spaces equal around the lateral incisors",
    value: "Keep spaces equal around the lateral incisors"
  },
  {
    label: "Keep the spaces distal to the canines",
    value: "Keep the spaces distal to the canines"
  },
  {
    label: "Not correct the spacing",
    value: "Not correct the spacing"
  },
]

export const overbiteData = [
  {
    label: "Upper intrusion of incisors",
    value: "Upper intrusion of incisors"
  },
  {
    label: "Lower intrusion of incisors",
    value: "Lower intrusion of incisors"
  },
  {
    label: "Upper and lower intrusion of incisors",
    value: "Upper and lower intrusion of incisors"
  },
]

export const openbiteData = [
  {
    label: "Upper extrusion of incisors",
    value: "Upper extrusion of incisors"
  },
  {
    label: "Lower extrusion of incisors",
    value: "Lower extrusion of incisors"
  },
  {
    label: "Upper and lower extrusion of incisors",
    value: "Upper and lower extrusion of incisors"
  },
]

export const classIIData = [
  {
    label: "Distalisation sequential 2 mm with cuts on the upper canines and windows on the lower first molars + derotation of the upper molars + stripping distal to 13, 14, 15, 23, 24, 25 if needed",
    value: "Distalisation sequential 2 mm with cuts on the upper canines and windows on the lower first molars + derotation of the upper molars + stripping distal to 13, 14, 15, 23, 24, 25 if needed"
  },
  {
    label: "Distalisation 2 mm + derotation of molars with a 2 mm anetro posterior jump (ONLY for kids and teens).",
    value: "Distalisation 2 mm + derotation of molars with a 2 mm anetro posterior jump (ONLY for kids and teens)."
  },
  {
    label: "Extraction of 14, 24 and space closure (for advanced users)",
    value: "Extraction of 14, 24 and space closure (for advanced users)"
  },
]

export const classIIIData = [
  {
    label: "Distalisation of lower molars till 2 mm with derotation of with hooks on the lower canines and cuts on the upper molars + stripping distal to 33, 34, 35, 43, 44, 45 (ONLY if stripping is needed)",
    value: "Distalisation of lower molars till 2 mm with derotation of with hooks on the lower canines and cuts on the upper molars + stripping distal to 33, 34, 35, 43, 44, 45 (ONLY if stripping is needed)"
  },
  {
    label: "Extraction of 34, 44 for advanced users only",
    value: "Extraction of 34, 44 for advanced users only"
  },
  {
    label: "Extraction of lower incisor to resolve the anterior crowding",
    value: "Extraction of lower incisor to resolve the anterior crowding"
  },
]

export const crossbiteData = [
  {
    label: "Cuts on the palatal of the teeth that need to be pushed buccally and the buccal on the opposing teeth to put elastics, and expansion to correct the cross bite",
    value: "Cuts on the palatal of the teeth that need to be pushed buccally and the buccal on the opposing teeth to put elastics, and expansion to correct the cross bite"
  },
  {
    label: "Not correct the crossbite",
    value: "Not correct the crossbite"
  },
]